<template>
<div>
    <b-button @click="showModal">
        Скачать КП
    </b-button>
    <b-modal id="modal-center" ref="myModalRef" hide-footer title='Заполните поля'>
        <div class="d-block text-center">

            <b-form @submit.stop.prevent>
                <label for="user_name">Имя</label>
                <b-input v-model="user.name"  id="user_name"></b-input>
                <label for="user_org">Организация</label>
                <b-input v-model="user.org"  id="user_org"></b-input>
                <label for="user_tel">Телефон</label>
                <b-input v-model="user.tel" type="number" id="user_tel"></b-input>
                <label for="user_email">E-mail</label>
                <b-input v-model="user.email"  id="user_email"></b-input>
               
            </b-form>
            <br>
            <button class="btn btn-success "  @click="subForm" v-if = "isValid">Скачать КП</button>
        </div>
        
    </b-modal>
</div>
</template>

<script>
export default {
    data(){
        return{
            user:{
                name:'',
                org:'',
                tel:'',
                email:''
            }
        }
    },
    methods: {
        showModal() {
            this.$refs.myModalRef.show()
        },
        hideModal() {
            this.user={
                name:'',
                org:'',
                tel:'',
                email:''
            }
            this.$refs.myModalRef.hide()
        },
        subForm(){
            this.$emit('cloze',this.user)
            this.user={
                name:'',
                org:'',
                tel:'',
                email:''}
            this.$refs.myModalRef.hide()
        }
    },
    computed:{
        isValid(){
            let e = false
            if(this.user.name.length > 3 &&
                this.user.org.length > 3 &&
                this.user.tel.length > 3 &&
                this.user.email.length > 3)
                {e = true}
            
            return e
        }
    }

}
</script>

<style>

</style>
